import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";
import scroll from "modules/utils/scroll";
import { useDispatch, useSelector } from "react-redux";
import {
  disableAllMenu,
  expandImageUrl,
  isActiveExpandImageModal,
  isActiveSosongTermSearch,
  isActiveSosongGuideModal
} from "modules/actions/statusMenu";

/**
 * Simple
 */
const Simple = ({ boxStyle, item, viewType, idx }) => {
  // console.log("ReactHtmlParser")
  // console.log('item ::: ' ,JSON.stringify(item) );
  const ImageStyle = JSON.parse(JSON.stringify(boxStyle));
  const messageText = item.text;
  const [termSearchView, setTermSearchView] = useState(false);
  const dispatch = useDispatch();
  const explainImage =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH7SURBVHgBjVRLktpADJUavPcRnBOE3MCcIHMDTIBhdoEKVM0uwy4VXBWySoqfzQmSOQHkBPEROILX448itQ0xniYZLfzplp5eS0+NYLD+ZOUSYYdU7iKBoxcRI35EgPC4+dz/WY/B6s/d/TcnSZsBALnlUswesf4isPlpl1FHq2G1v3/qHp8BDabLVk6wF2cEPPB7tvYHh2dMIfc4rCNJFEJ7Nb+NzkAFk8bvAoTGa3+4gH/Yu8lqxH5fBMxqWm+EmZKNJFP7ayB394FTB9r6gwUBjiUmSdNAM+p9WN8A5j8AVbiZ97sXmafLgCm79XqcrDdZ7aWeXIq2ApW/1YhEu7ojrzFJcJIs2ZuYcZKZvKXDCglbctZ6YcU2/tBjt901sDImZjKuIqDWucUG+x8Y045lT8ELzGrmDzozBzylT57JRzHisRSb0bQ0yq4Ks60/fLhwILQRIVIM8kucRGxXQQgdPv7X4ph/rYyxCVTE4lShBgb4WHXyRoF9AuHWzTbz21E9ESF19Admj1rZJz1w4cfbiiBFY4iZY1J6b7p8z9kXMnec5JUG8vgIjXJE6mAmO4NwAzIekZDFahxaUbkI1Dy0UgJ9O8QZD21YHdpzXYTZqbiFxVRqDCvXiNwOabPZDU3XyAV1PX/ZDTfitRZs4XlUuTpwgXemKfgDghsJNTjNmn8AAAAASUVORK5CYII=";
  let isAddTermMsg = false;
  if(item?.text === "추가로 궁금하신 점이 있다면 아래 채팅창에 입력해주세요.") {
    isAddTermMsg = true;
  }
    
    // 웹접근성: table에 대한 caption 필요
    const captionReplaceText = item.text.replace(/\*\*\*caption:([^\r\n]+)(\r|\n|<br>)+<table>/g, '<table><caption>$1</caption>');
    
    const onSosongTermSearch = () => {
      dispatch(isActiveSosongTermSearch());
    };

    const onSosongGuide = () => {
      dispatch(isActiveSosongGuideModal());
    }
  const handleOnError = (event) => {
    event.currentTarget.src = "images/noimage.png";
    event.currentTarget.className = "errorImg";
    event.currentTarget.alt = "이미지 로드 실패";
    };
  useEffect(() => {
    if(messageText === '연관 용어 찾기 안내입니다.') {
      onSosongTermSearch();
    }

    if(messageText === '소송절차 안내도입니다.') {
      onSosongGuide();
    }
  },[messageText])

  useLayoutEffect(() => {
    const aTag = document.querySelector('a');
    if(aTag) {
      aTag.setAttribute('target','_blank');
    }
  },[messageText])
  const ImageBox = useRef();
  const expandImage = (domTarget) => {
    // event.currentTarget.src = 'images/noimage.png';
    // event.currentTarget.className = 'errorImg';
    // event.currentTarget.alt = '이미지 로드 실패';
    const imgElement =
      domTarget.querySelector("._message > img") === null
        ? domTarget.querySelector("._message2 > img")
        : domTarget.querySelector("._message > img");

    dispatch(disableAllMenu());
    dispatch(isActiveExpandImageModal(true));
    dispatch(expandImageUrl(imgElement.src));
  };

  const text = useRef();
  let classTitle = "_message";
  if (idx !== 0 && !isAddTermMsg) {
    classTitle = "_message2";
  }

  let ImageTagCheck = false;
  if (item.text.includes("<img")) {
    ImageTagCheck = true;
    ImageStyle.cursor = "pointer";
  }

  text.current?.childNodes.forEach((ele, i) => {
    if (ele.tagName === "IMG") {
      if (explainImage === ele.src) {
        ele.style.display = "inline";
        ele.style["max-width"] = "3%";
        ImageTagCheck = false;
      }
      ele.onload = () => {
        scroll();
      };
    }
  });

  return (
    <div className="_text_div">
      {ImageTagCheck ? (
        <div
          className={classTitle}
          style={ImageStyle}
          ref={text}
          onClick={(e) => {
            expandImage(e.currentTarget);
          }}
        >
          {ReactHtmlParser(item.text || "")}
        </div>
      ) : (
        <div className={classTitle} style={boxStyle} ref={text}>
          {ReactHtmlParser(captionReplaceText || "")}
        </div>
      )}
    </div>
  );
};
Simple.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  idx: PropTypes.number,
};
Simple.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: "advise", // advise, simulator, knowledge
  idx: 0,
};

export default Simple;
